<template>
    <div class='header'>
        <div class='max-width'>
            <p class='name'>{{ name }} さん</p>
            <div class='mypage-wrapper'>
                <router-link class='mypage' :to="{ path: '/photobuy/mypage' }">マイページ</router-link>
                <i class="fas fa-home home"></i>
            </div>
            <div class='cart-wrapper' @click='toCart'>
                <p>カート</p>
                <p class='cart-amount'> {{ cartAmount }} </p>
                <i class="fas fa-shopping-cart cart"></i>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Header',
    props: ['cartAmount'],
    components: {
    },
    data () {
        return {
            name: ''
        }
    },
    mounted () {
        const self = this

        self.axios.get(`${process.env.API_URL}/name`).then((res) => {
            if (res.data.message === 'OK') {
                self.name = res.data.name
            }
        }).catch((e) => {
            console.log(e)
            alert('サーバーエラーが発生しました')
        })
    },
    methods: {
        toCart () {
            this.$router.push('/photobuy/cart')
        }
    }
}
</script>

<style scoped>

.header {
    height: 80px;
    padding-top: 15px;
    padding-left: 22px;
    border-bottom: 3px solid #f5f5f5;
    min-width: 600px;
    width: 100%;
    background: white;
    position: fixed;
    z-index: 100;
    top: 0;
}

.name, .mypage {
    max-width: 158px;
    font-size: 19px;
    font-weight: bold;
    line-height: 50px;
    color: #4a4a4a;
}

.select {
    margin-left: 20px;
}

.title {
    line-height: 50px;
    margin-left: 24px;
}

.cart-wrapper {
    line-height: 26px;
    margin-left: auto;
    margin-right: 10px;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 12px;
    display: flex;
    font-weight: bold;
    cursor: pointer;
}

.cart-wrapper:hover {
    border-radius: 3px;
    background: rgba(0, 0, 0, 0.1);
}

.cart-wrapper p {
    font-size: 19px;
}

.cart {
    margin-left: 14px;
    height: 25px;
    width: 25px;
}

.home {
    padding-top: 5px;
    margin-top: 8px;
    height: 25px;
    width: 25px;
}

.cart-amount {
    padding-left: 5px;
    color: #ff8c00;
}

.max-width {
    display: flex;
    max-width: 1280px;
    margin: auto;
}

.mypage-wrapper {
    cursor: pointer;
    padding-left: 10px;
    margin-left: 20px;
    padding-right: 10px;
    width: 147px;
}

.mypage-wrapper:hover {
    border-radius: 3px;
    background: rgba(0, 0, 0, 0.1);
}

@media (max-width: 600px) {
    .header {
        width: 100%;
        min-width: 100vw;
        position: relative;
    }
    .name {
        display: none;
    }
    .mypage-wrapper {
        margin-left: 0px;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/photobuy/Header.vue